import { create } from "zustand";

import { CustomColors } from "@type/CustomPalette";

export type ThemeVariants = CustomColors | "default" | undefined;

type CustomThemeStore = {
  logo?: string;
  color?: ThemeVariants;
  setLogo(url?: string): void;
  setColor(color?: ThemeVariants): void;
};

export const useCustomThemeStore = create<CustomThemeStore>((set) => ({
  logo: undefined,
  color: undefined,
  setLogo: (logo): void =>
    set(() => ({
      logo,
    })),
  setColor: (color: ThemeVariants): void =>
    set(() => ({
      color,
    })),
}));
